import React from 'react'

import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'

import { TrustPilotControl } from './TrustPilotControl'
import { TrustPilotVariant } from './TrustPilotVariant'

const TrustPilot = () => {
  const isTrustPilotSliderFeatureFlagEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_trustpilot_slider_widget_web_enabled',
  )

  return isTrustPilotSliderFeatureFlagEnabled ? <TrustPilotVariant /> : <TrustPilotControl />
}

export { TrustPilot }
